/* import __COLOCATED_TEMPLATE__ from './viewed-list.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';

export default class ViewedList extends Component {
  get titleComponent() {
    return 'stats-system/list/checklist/header/viewed-title';
  }
}
